import { Component } from '@angular/core';

@Component({
  selector: 'app-asset-vehicle-landing',
  templateUrl: './asset-vehicle-landing.component.html',
  styleUrls: ['./asset-vehicle-landing.component.scss']
})
export class AssetVehicleLandingComponent {

}
